import {
	createHoverActionsContainer,
	SEARCHBAR_ACTIONS,
} from "../components/header-components/ActionButtons";
import { HeaderElement } from "../types";

// SearchBar Component as HeaderElement Object - Full Size Version
const searchBarFullElement: HeaderElement = {
	id: "searchbar-full-1",
	type: "SearchBar",
	tagName: "div",
	data: {
		// Component settings/configuration
		size: "full", // "full" or "icon"
		design: "default", // "minimal", "rounded", "filled", "shadowed", "default"
		icon: "search",
		placeholder: "Search...",

		// Component behavior settings
		isSelectable: true,
		isDeletable: true,
		hasHoverActions: true,

		// Event handlers
		onClick: "handleSearchBarClick",
		onRemove: "handleSearchBarRemove",
		onEdit: "handleSearchBarEdit",
		onInputClick: "handleSearchInputClick",
	},
	className: "searchbar-container",
	style: {
		position: "relative",
		cursor: "pointer",
		padding: "8px",
	},
	props: {
		onClick: "handleClick",
		role: "search",
		tabIndex: 0,
	},
	children: [
		// Search Input Container
		{
			id: "searchbar-input-container",
			type: "SearchInputContainer",
			tagName: "div",
			data: {
				design: "default",
			},
			className: "search-input-container design-default",
			style: {
				display: "flex",
				alignItems: "center",
			},
			children: [
				// Search Icon
				{
					id: "searchbar-icon",
					type: "SearchIcon",
					tagName: "span",
					data: {
						icon: "search",
					},
					className: "search-icon",
					children: [
						{
							id: "search-icon-svg",
							type: "Icon",
							tagName: "svg",
							data: {
								icon: "search",
							},
							props: {
								width: "16",
								height: "16",
								viewBox: "0 0 24 24",
								fill: "none",
								stroke: "currentColor",
							},
							children: [],
						},
					],
				},

				// Search Input
				{
					id: "searchbar-input",
					type: "SearchInput",
					tagName: "input",
					data: {
						placeholder: "Search...",
					},
					className: "search-input",
					props: {
						type: "text",
						placeholder: "Search...",
						onClick: "handleSearchInputClick",
					},
					style: {
						fontSize: "14px",
					},
				},
			],
		},

		// Hover Actions Container
		{
			id: "searchbar-hover-actions",
			type: "HoverActions",
			tagName: "div",
			data: {
				showOnHover: true,
			},
			className: "hover-actions",
			style: {
				position: "absolute",
				top: "0",
				right: "0",
			},
			children: [
				// Edit Button
				{
					id: "searchbar-edit-button",
					type: "ActionButton",
					tagName: "button",
					data: {
						action: "edit",
						icon: "setting",
					},
					className: "action-btn edit-btn",
					props: {
						onClick: "handleEditClick",
					},
					children: [
						{
							id: "edit-icon",
							type: "Icon",
							tagName: "svg",
							data: {
								icon: "setting",
							},
							props: {
								width: "16",
								height: "16",
								viewBox: "0 0 24 24",
								fill: "none",
								stroke: "currentColor",
							},
							className: "btn-icon",
							children: [],
						},
					],
				},

				// Remove Button
				{
					id: "searchbar-remove-button",
					type: "ActionButton",
					tagName: "button",
					data: {
						action: "remove",
						icon: "trash",
					},
					className: "action-btn remove-btn",
					props: {
						onClick: "handleRemoveClick",
					},
					children: [
						{
							id: "remove-icon",
							type: "Icon",
							tagName: "span",
							data: {
								icon: "trash",
							},
							className: "btn-icon",
							children: [],
						},
					],
				},
			],
		},
	],

	css: `
        .searchbar-container {
            position: relative;
            cursor: pointer;
            padding: 8px;
        }
        
        .searchbar-container.selected {
            border: 2px dashed #2196f3;
        }
        
        /* Search Input Container Base Styles */
        .search-input-container {
            display: flex;
            align-items: center;
        }
        
        /* Design Templates */
        .search-input-container.design-default {
            border: 1px solid #e5e7eb;
            border-radius: 0.375rem;
            padding: 8px 12px;
            background: transparent;
        }
        
        .search-input-container.design-minimal {
            border: none;
            border-bottom: 1px solid #e5e7eb;
            border-radius: 0;
            padding: 8px 0;
            background: transparent;
        }
        
        .search-input-container.design-rounded {
            border: 1px solid #e5e7eb;
            border-radius: 9999px;
            padding: 8px 16px;
            background: transparent;
        }
        
        .search-input-container.design-filled {
            border: none;
            border-radius: 0.375rem;
            padding: 8px 12px;
            background: #f3f4f6;
        }
        
        .search-input-container.design-shadowed {
            border: 1px solid #e5e7eb;
            border-radius: 0.375rem;
            padding: 8px 12px;
            background: transparent;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        /* Search Icon */
        .search-icon {
            color: #9ca3af;
            margin-right: 8px;
            display: flex;
            align-items: center;
        }
        
        /* Search Input */
        .search-input {
            border: none;
            outline: none;
            background: transparent;
            font-size: 14px;
        }
        
        .search-input::placeholder {
            color: #9ca3af;
        }
        
        /* Hover Actions */
        .hover-actions {
            position: absolute;
            top: 0;
            right: 0;
            opacity: 0;
            background-color: rgba(0, 0, 0, 0.7);
            padding: 4px;
            border-radius: 4px;
            display: flex;
            transition: opacity 0.2s ease;
        }
        
        .searchbar-container:hover .hover-actions {
            opacity: 1;
        }
        
        .action-btn {
            padding: 4px 8px;
            margin: 0 2px;
            color: white;
            background: none;
            border: none;
            cursor: pointer;
            border-radius: 2px;
            transition: all 0.2s ease;
        }
        
        .edit-btn:hover {
            color: #64b5f6;
            transform: scale(1.1);
        }
        
        .remove-btn:hover {
            color: #f48fb1;
            transform: scale(1.1);
        }
        
        .btn-icon {
            font-size: 12px;
            display: inline-block;
        }
    `,
};

// SearchBar Component as HeaderElement Object - Icon Only Version
const searchBarIconElement: HeaderElement = {
	id: "searchbar-icon-1",
	type: "SearchBar",
	tagName: "div",
	data: {
		size: "icon",
		design: "default",
		icon: "search",

		// Component behavior settings
		isSelectable: true,
		isDeletable: true,
		hasHoverActions: true,

		// Event handlers
		onClick: "handleSearchBarClick",
		onRemove: "handleSearchBarRemove",
		onEdit: "handleSearchBarEdit",
	},
	className: "searchbar-container",
	style: {
		position: "relative",
		cursor: "pointer",
		padding: "8px",
	},
	props: {
		onClick: "handleClick",
		role: "button",
		tabIndex: 0,
	},
	children: [
		// Search Icon Button
		{
			id: "searchbar-icon-button",
			type: "SearchIconButton",
			tagName: "button",
			data: {
				icon: "search",
			},
			className: "search-icon-button",
			props: {
				onClick: "handleIconButtonClick",
			},
			children: [
				{
					id: "search-button-icon",
					type: "Icon",
					tagName: "svg",
					data: {
						icon: "search",
					},
					props: {
						width: "16",
						height: "16",
						viewBox: "0 0 24 24",
						fill: "none",
						stroke: "currentColor",
					},
					children: [],
				},
			],
		},
	],

	css: `
        .searchbar-container {
            position: relative;
            cursor: pointer;
            padding: 8px;
        }
        
        .searchbar-container.selected {
            border: 2px dashed #2196f3;
        }
        
        /* Search Icon Button */
        .search-icon-button {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px;
            border-radius: 9999px;
            background: transparent;
            border: none;
            cursor: pointer;
            transition: background-color 0.2s ease;
        }
        
        .search-icon-button:hover {
            background-color: #f3f4f6;
        }
        
        /* Hover Actions */
        .hover-actions {
            position: absolute;
            top: 0;
            right: 0;
            opacity: 0;
            background-color: rgba(0, 0, 0, 0.7);
            padding: 4px;
            border-radius: 4px;
            display: flex;
            transition: opacity 0.2s ease;
        }
        
        .searchbar-container:hover .hover-actions {
            opacity: 1;
        }
        
        .action-btn {
            padding: 4px 8px;
            margin: 0 2px;
            color: white;
            background: none;
            border: none;
            cursor: pointer;
            border-radius: 2px;
            transition: all 0.2s ease;
        }
        
        .edit-btn:hover {
            color: #64b5f6;
            transform: scale(1.1);
        }
        
        .remove-btn:hover {
            color: #f48fb1;
            transform: scale(1.1);
        }
        
        .btn-icon {
            font-size: 12px;
            display: inline-block;
        }
    `,
};

// Factory function to create search bar elements with different configurations
const createSearchBarElement = (
	config: {
		id: string;
		size: "full" | "icon";
		design?: "minimal" | "rounded" | "filled" | "shadowed" | "default";
		placeholder?: string;
		icon?: string;
		width?: string;
		customStyles?: React.CSSProperties;
	},
	publishMode = false
): HeaderElement => {
	const isFullSize = config.size === "full";
	const design = config.design || "default";

	const baseElement: HeaderElement = {
		id: config.id,
		type: "SearchBar",
		tagName: "div",
		props: { onClick: "handleEditClick" },
		data: {
			size: config.size,
			design: design,
			icon: config.icon || "search",
			placeholder: config.placeholder || "Search...",
			width: config.width || "250px",
			isSelectable: true,
			isDeletable: true,
			hasHoverActions: true,
		},
		className: "searchbar-container",
		style: {
			position: "relative",
			cursor: "pointer",
			padding: "8px",
			flex: "1 1 0%",
			...config.customStyles,
		},
		children: [],
		css: "",
	};

	if (isFullSize) {
		// Add full search bar children
		baseElement.children = [
			{
				id: `${config.id}-input-container`,
				type: "SearchInputContainer",
				tagName: "div",
				data: { design },
				props: { onClick: "handleEditClick" },
				className: `search-input-container design-${design}`,
				style: {
					display: "flex",
					alignItems: "center",
					width: "100%",
					minWidth: config.width || "250px",
				},
				children: [
					{
						id: `${config.id}-icon`,
						type: "Icon",
						tagName: "span",
						className: "search-icon",
						style: {
							padding: "0 8px",
						},
						props: { onClick: "handleEditClick" },
						data: { icon: config.icon || "search" },
						children: [],
					},
					{
						id: `${config.id}-input`,
						type: "SearchInput",
						tagName: "input",
						className: "search-input",
						props: {
							type: "text",
							placeholder: config.placeholder || "Search...",
						},
						data: {
							placeholder: config.placeholder || "Search...",
						},
					},
				],
			},
			// Hover Actions Container (same as full version)
			...[
				!publishMode
					? createHoverActionsContainer(config.id, SEARCHBAR_ACTIONS)
					: ([] as any),
			],
		];

		baseElement.css = searchBarFullElement.css || "";
	} else {
		// Add icon-only search bar children
		baseElement.children = [
			{
				id: `${config.id}-icon-button`,
				type: "SearchIconButton",
				tagName: "button",
				className: "search-icon-button",
				data: { icon: config.icon || "search" },
				children: [],
			},
			// Hover Actions Container (same as full version)
			createHoverActionsContainer(config.id, SEARCHBAR_ACTIONS),
		];

		baseElement.css = searchBarIconElement.css || "";
	}

	return baseElement;
};

export { createSearchBarElement, searchBarFullElement, searchBarIconElement };
